import { render, staticRenderFns } from "./MaidTransaction.vue?vue&type=template&id=4715b958&"
import script from "./MaidTransaction.vue?vue&type=script&lang=js&"
export * from "./MaidTransaction.vue?vue&type=script&lang=js&"
import style0 from "./MaidTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidTransaction.vue"
export default component.exports